import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { FlashItem } from './item';
import {classes, style} from 'typestyle';
import {mediaMobileOnly} from '../../theme/media';
import {constantHeaderHeight} from '../../theme/constant';
import {rem} from 'csx';
import {zFlash} from '../../theme/z';
import {end, startJustified, vertical} from 'csstips';

export interface FlashContainerProps {

}

@inject(deps) @observer
export class FlashContainer extends Component<FlashContainerProps> {
  render() {
    const { unseen = [] } = this.props.model.flash;
    const { toggleSeen } = this.props.controller.flash;
    const { firstPaint, isMobile } = this.props.model.ui;

    if (firstPaint || isMobile || unseen.length === 0) {
      return null;
    }

    return (
      <ReactCSSTransitionGroup
        component="div"
        className={classes(FlashContainer.styles.container, unseen.length === 0 && FlashContainer.styles.containerHidden)}
        transitionName={FlashContainer.styles}
        transitionAppear={true}
        transitionAppearTimeout={300}
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}>
        {unseen.map((message) => (
          <FlashItem
            key={message.identity}
            message={message}
            onRequestClose={() => toggleSeen(message.identity)}
          />
        ))}
      </ReactCSSTransitionGroup>
    )
  }

  static styles = {
    container: style(
      {
        ...vertical,
        ...end,
        ...startJustified,
        transition: `right 0.2s linear, top 0.3s ease-in-out`,
        position: 'fixed',
        top: `calc(${constantHeaderHeight} + 1.25rem)`,
        left: 0,
        right: rem(3.125),
        padding: rem(0.625),
        zIndex: zFlash,
        $nest: {
          '& > div': {
            position: 'absolute',
          }
        }
      },
      mediaMobileOnly({
        display: 'none',
        top: 0,
        left: 0,
      })
    ),
    containerHidden: style({
      display: 'none'
    }),

    enter: style({
      opacity: 0.01,
      transform: `translateY(-20%) scale(0.6)`
    }),
    enterActive: style({
      opacity: 1,
      transform: `translateY(0) scale(1)`,
      transition: `opacity 100ms ease-in 200ms, transform 300ms ease-in`
    }),
    leave: style({
      opacity: 1,
      transform: 'translateY(0)'
    }),
    leaveActive: style({
      opacity: 0.01,
      transform: `translateY(-20%) scale(0.6)`,
      transition: `opacity 100ms ease-in 200ms, transform 300ms ease-in`
    }),
    appear: style({
      opacity: 0.01,
      transform: `translateY(-20%) scale(0.6)`
    }),
    appearActive: style({
      opacity: 1,
      transform: `translateY(0) scale(1)`,
      transition: `opacity 100ms ease-in 200ms, transform 300ms ease-in`
    }),
  }
}
